<template>
  <div>
    <h1>这是预渲染测试页面</h1>
  </div>
</template>

<script>
export default {
  mounted() {
    this.$nextTick(() => {
      console.log('✅ render-event dispatched')
      document.dispatchEvent(new Event('render-event'))
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/views/test-prerender/index.vue